import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import ItemSimple from "../Shared/ItemSimple"
import LienClinics from "./LienClinics"
import LienAddresses from "./LienAddresses"
import LientTable from "./LientTable"
import { returnPractice } from "../../../../lib/script"

import classes from '../Shared/Item.module.css'
import { practicesFunctions } from "../../../../lib/practices"


export default function LienItem() {
    const activeCase = useSelector(state => state.case.activeCase) 

    const [practicesData, setPracticesData] = useState(null)


    useEffect(() => {
        if (activeCase && activeCase.practices) {

            let items = activeCase.practices
            let newitems = items.filter(element => practicesFunctions.isPracticeLienEligible(element.practice_id)).map(element => {
                return {
                    ...element,
                    practiceDetailed: returnPractice(element.practice_id)
                }
            });           

            setPracticesData(newitems)
        }

        

    }, [activeCase])    

    const doNotLienEngaged = Boolean(activeCase?.case?.do_not_lien)

    return <ItemSimple>
        {doNotLienEngaged && (
            <div className={classes.item_inner} style={{ marginBottom: 8 }}>
                <span style={{ fontWeight: 600, color: '#b45309' }}>Do Not Lien — engaged</span>
            </div>
        )}
        <div className={classes.item_inner}>
            <LienClinics items={practicesData}/>
            <LienAddresses />
        </div>

        {practicesData &&  <LientTable items={practicesData}/>}
    </ItemSimple>
}